const dashboardInitialState = {
    leaderboards:[],
    momUserEntries:[],
    topUsersWithDailyCount:[],
    topEntries:[],
    currentMonthEntriesByUser: [],
    isLoading: false,

}
export default dashboardInitialState;